import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MailLogger from './mailLogger'
import { createProvider } from './vue-apollo'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import { faPen } from '@fortawesome/free-solid-svg-icons'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { faPrint } from '@fortawesome/free-solid-svg-icons'
import { faSync } from '@fortawesome/free-solid-svg-icons'
import { faShareAlt } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'regenerator-runtime/runtime'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueRamda from 'vue-ramda'
import HelperFunctions from './helperFunctions'

Vue.config.productionTip = false

store.subscribe((mutation, state) => {
  // Store the state object as a JSON string
  localStorage.setItem('autoscoutstore', JSON.stringify(state));
});

Vue.use(MailLogger) // options is optional
Vue.use(HelperFunctions) // options is optional

library.add(faArrowAltCircleRight)
library.add(faAngleDoubleDown)
library.add(faPen)
library.add(faPhone)
library.add(faEnvelope)
library.add(faShareAlt)
library.add(faPrint)
library.add(faSync)
library.add(faFacebookF)
library.add(faTwitter)
library.add(faLink)

Vue.component('font-awesome-icon', FontAwesomeIcon)

const options = { name: 'custom', lodash: lodash } // customize the way you want to call it

Vue.use(VueLodash, options) // options is optional
Vue.use(VueRamda)

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App),
  beforeCreate() {
    this.$store.commit('initialiseStore');
    this.$store.commit('updateSiteUrl', typeof window.siteUrl!=='undefined' && window.siteUrl!=='' ? window.siteUrl : 'https://www.autohaeuser-pohlheim.de');
    this.$store.commit('updateCarOfTheWeek', typeof window.carOfTheWeekId!=='undefined' && window.carOfTheWeekId!=='' ? window.carOfTheWeekId : 'no-car-set');
    this.$store.commit('updateMarketPath', typeof window.pathToMarket!=='undefined' && window.pathToMarket!=='' ? window.pathToMarket : '/fahrzeuge/gebrauchtwagen/fahrzeugsuche/fahrzeuge');
    this.$store.commit('updateDetailsPath', typeof window.pathToDetails!=='undefined' && window.pathToDetails!=='' ? window.pathToDetails : '/fahrzeuge/gebrauchtwagen/fahrzeugsuche/fahrzeugdetails');
    this.$store.commit('updateVWPhonenumber', typeof window.phoneLocationVW!=='undefined' && window.phoneLocationVW!=='' ? window.phoneLocationVW : '+49 6403 9595-0');
    this.$store.commit('updateSEATPhonenumber', typeof window.phoneLocationSEAT!=='undefined' && window.phoneLocationSEAT!=='' ? window.phoneLocationSEAT : '+49 6403 9595-0');
    this.$store.commit('updateFCAPhonenumber', typeof window.phoneLocationFCA!=='undefined' && window.phoneLocationFCA!=='' ? window.phoneLocationFCA : '+49 6403 9595-0');
    this.$store.commit('updateAutoCRMLeadnumber', typeof window.phoneAutoCRMLead!=='undefined' && window.phoneAutoCRMLead!=='' ? window.phoneAutoCRMLead : '+496403 78434994');

  }
}).$mount('#autoscout-app')
